(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v-bts-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-bts-community')) {
    customElements.define(
      'v-bts-community',
      class VBtsCommunity extends HTMLElement {
        connectedCallback() {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('autoplay');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-bts-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let overlay = null;
    let closeBtn = null;
    let escHandler = null;

    const closeFullscreen = () => {
      if (escHandler) {
        document.removeEventListener('keydown', escHandler);
        escHandler = null;
      }

      closeBtn?.remove();
      overlay?.remove();
      closeBtn = null;
      overlay = null;
    };

    const mountFullscreenOverlay = (mediaElement) => {
      closeFullscreen();

      overlay = document.createElement('div');
      overlay.className = 'video-page-fullscreen-overlay active';

      const container = document.createElement('div');
      container.className = 'video-page-fullscreen-overlay__container';
      container.appendChild(mediaElement);
      overlay.appendChild(container);
      document.body.appendChild(overlay);

      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'video-page-fullscreen-overlay__close';
      closeBtn.innerHTML = '×';
      closeBtn.setAttribute('aria-label', 'Close fullscreen video');
      closeBtn.addEventListener('click', closeFullscreen);
      document.body.appendChild(closeBtn);

      escHandler = (event) => {
        if (event.key === 'Escape') closeFullscreen();
      };
      document.addEventListener('keydown', escHandler);
    };

    const getHeroRoot = (button) => button.closest('v-bts-hero') || button.closest('.v-bts-hero');

    const getActiveHeroVideo = (hero) => {
      if (!hero) return null;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const mobileWrap = hero.querySelector('.v-bts-hero__picture--mobile');
      const desktopWrap = hero.querySelector('.v-bts-hero__picture--desktop');

      if (isMobile && mobileWrap) {
        return mobileWrap.querySelector('video');
      }

      if (desktopWrap) {
        return desktopWrap.querySelector('video');
      }

      return hero.querySelector('.v-bts-hero__video');
    };

    const getVideoUrl = (video) => {
      if (!video) return '';

      return (
        video.currentSrc ||
        video.getAttribute('src') ||
        video.querySelector('source')?.src ||
        ''
      );
    };

    const getFullscreenVideoSrc = (button, hero) => {
      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const mobileSrc = button.getAttribute('data-fullscreen-video-src-mobile');
      const desktopSrc = button.getAttribute('data-fullscreen-video-src');

      if (isMobile && mobileSrc) return mobileSrc;
      if (desktopSrc) return desktopSrc;
      if (mobileSrc) return mobileSrc;

      return getVideoUrl(getActiveHeroVideo(hero));
    };

    const buildFullscreenVideo = (button, hero) => {
      const sourceVideo = getActiveHeroVideo(hero);
      const video = document.createElement('video');
      video.className = 'video-page-fullscreen-overlay__video';
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.muted = false;
      video.loop = false;

      if (sourceVideo) {
        sourceVideo.querySelectorAll('source').forEach((source) => {
          video.appendChild(source.cloneNode(true));
        });

        const sourceUrl = getVideoUrl(sourceVideo);
        if (sourceUrl) {
          video.src = sourceUrl;
        }
      } else {
        const fallbackSrc = getFullscreenVideoSrc(button, hero);
        if (!fallbackSrc) return null;
        video.src = fallbackSrc;
      }

      return video;
    };

    const openFullscreen = (button) => {
      const hero = getHeroRoot(button);
      const video = buildFullscreenVideo(button, hero);
      if (!video) return;

      mountFullscreenOverlay(video);
      video.play().catch(() => {});
    };

    if (!window.__vBtsHeroPlayBound) {
      window.__vBtsHeroPlayBound = true;

      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-v-bts-hero-play]');
        if (!button) return;

        event.preventDefault();
        openFullscreen(button);
      });
    }

    if (!customElements.get('v-bts-hero')) {
      customElements.define(
        'v-bts-hero',
        class VBtsHero extends HTMLElement {
          connectedCallback() {
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

            this.querySelectorAll('video').forEach((video) => {
              video.pause();
              video.removeAttribute('autoplay');
            });
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-bts-recipes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-bts-recipes')) {
    class VBtsRecipes extends HTMLElement {
      connectedCallback() {
        this.addEventListener('shopify:section:select', this._onSectionSelect);
        this.addEventListener('shopify:section:deselect', this._onSectionDeselect);
      }

      disconnectedCallback() {
        this.removeEventListener('shopify:section:select', this._onSectionSelect);
        this.removeEventListener('shopify:section:deselect', this._onSectionDeselect);
      }

      _onSectionSelect = () => {
        this.classList.add('is-editor-selected');
      };

      _onSectionDeselect = () => {
        this.classList.remove('is-editor-selected');
      };
    }

    customElements.define('v-bts-recipes', VBtsRecipes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-bts-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('v-bts-story')) {
    customElements.define(
      'v-bts-story',
      class VBtsStory extends HTMLElement {
        connectedCallback() {
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('autoplay');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
